





































import Vue from "vue";
import Component from "vue-class-component";
import { ReportDetail_report_attachments } from "@/models/queries/types/ReportDetail";
import AttachmentCard from "@/components/reports/partials/attachment-card.vue";
import { Fragment } from "vue-fragment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import * as _ from "lodash";
@Component({
  props: {
    attachments: Array,
    deletingAttachments: Array,
    report: Object,
    showDeleteConfirmation: Function,
    canDelete: Boolean,
    openImage: Function
  },
  components: {
    Fragment,
    ClipLoader,
    AttachmentCard
  }
})
export default class AttachmentCards extends Vue {
  get imageAttachments() {
    return _.orderBy(
      this.$props.attachments
        .filter(a => a.mimeType !== "application/pdf")
        .map(a => ({
          ...a,
          hasCharacteristic: !!a.characteristic
        })),
      ["hasCharacteristic", "fileName"],
      ["desc", "asc"]
    );
  }
  get pdfAttachments() {
    return _.orderBy(
      this.$props.attachments
        .filter(a => a.mimeType === "application/pdf")
        .map(a => ({
          ...a,
          hasCharacteristic: !!a.characteristic
        })),
      ["mc", "hasCharacteristic", "fileName"],
      ["desc", "desc", "asc"]
    );
  }
}
